import { render, staticRenderFns } from "./SocietiesTableWidget.vue?vue&type=template&id=b018ed4a&scoped=true"
import script from "./SocietiesTableWidget.vue?vue&type=script&lang=js"
export * from "./SocietiesTableWidget.vue?vue&type=script&lang=js"
import style0 from "./SocietiesTableWidget.vue?vue&type=style&index=0&id=b018ed4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b018ed4a",
  null
  
)

export default component.exports